import React, { Component } from 'react'
import { Button, Form, FormGroup,
         Label, Input, Col } from 'reactstrap';
import { activate } from '../../actions/activateActions';
import { connect } from 'react-redux';

class Activation extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activateCode: ''
    };
  }

  onBackClick = () => {
    console.log('back click');
    const { router } = this.context;
    router.history.push('/signup');
  }

  onActivateClick = () => {
    let accountId = localStorage.getItem('accountId');
    this.props.activate(accountId, this.state.activateCode);
  }

  onActivateChange = (e) => {
    let val = e.nativeEvent.target.value;
    this.setState({activateCode: val});
  }

  render() {
      return(
      <Col sm={6}>
        <br/>
        <div>
          <h4 className="title-screen">SIGN UP</h4>
          <Form>
           <FormGroup row>
             <Label for="phoneNumber" sm={4}>Phone number</Label>
             <Col sm={8}>
               <Input type="text" name="phone" id="phoneNumber"
                 placeholder=""
                 onChange={this.onActivateChange}
                 value={this.state.activateCode} />
             </Col>
           </FormGroup>

           <FormGroup row>
             <Col sm={6}>
                <Button color="warning" className="login-btn"
                  onClick={() => this.onBackClick()}>
                  BACK</Button>
             </Col>

             <Col sm={6}>
                <Button color="warning" className="activate-btn"
                  onClick={() => this.onActivateClick()}>
                  ACTIVATE MY ACCOUNT</Button>
             </Col>
           </FormGroup>
         </Form>
        </div>
      </Col>
    )
  }
}

Activation.contextTypes = {
  router: React.PropTypes.object
}

export default connect(
  null,
  { activate }
)(Activation);



// WEBPACK FOOTER //
// ./src/components/signup/Activation.js